import axios from '../../axios';

const path = '/rotations';

const service = {
  async createRotation(data) {
    return axios({ method: 'post', url: path, data });
  },

  async fetchRotations(params) {
    return axios({ method: 'get', url: path, params });
  },

  async updateRotation({ id, data }) {
    return axios({ method: 'put', url: `${path}/${id}`, data });
  },

  async deleteRotation(id) {
    return axios({ method: 'delete', url: `${path}/${id}` });
  }
};

export default service;
